import {MEDIA_CHANGED} from 'state/constants'

export function mediaChange(data) {
	return {
		type: MEDIA_CHANGED,
		data,
	}
}

// TODO untrack when hot reloading

let initData

let trackInnerWidth = false
let trackInnerHeight = false
let onResize
const getSizes = (data) => {
	if (trackInnerWidth) {
		data.innerWidth = global.innerWidth
	}
	if (trackInnerHeight) {
		data.innerHeight = global.innerHeight
	}
}
const makeOnResize = dispatch => () => {
	const data = {}
	getSizes(data)
	dispatch(mediaChange(data))
}
function trackMediaQuery(label, query, dispatch) {
	if (label === 'innerWidth' || label === 'innerHeight') {
		if (label === 'innerWidth') {
			trackInnerWidth = true
		}
		if (label === 'innerHeight') {
			trackInnerHeight = true
		}
		if (!onResize) {
			onResize = makeOnResize(dispatch)
			if (global.addEventListener) {
				global.addEventListener('resize', onResize, true)
			}
		}
		getSizes(initData)
		return
	}

	var mq = global.matchMedia(query)

	var listener = () => dispatch(mediaChange({
		[label]: mq.matches,
	}))

	mq.addListener(listener)

	initData[label] = mq.matches
}

export function mediaQueryTracker(queries) {
	return dispatch => {
		if (global.matchMedia) {
			initData = {}
			for (var label in queries) {
				trackMediaQuery(label, queries[label], dispatch)
			}
			dispatch(mediaChange(initData))
		}
	}
}



// WEBPACK FOOTER //
// ./state/actions/mediaQueryTracker.js